var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Heading as HeadingRebass, } from "rebass";
import { fontSizeBase, modularScale } from "src/styles/theme";
var fontStyles = {
    h1: fontSizeBase * modularScale * modularScale * modularScale * modularScale +
        "rem",
    h2: fontSizeBase * modularScale * modularScale * modularScale + "rem",
    h3: fontSizeBase * modularScale * modularScale + "rem",
    h4: fontSizeBase * modularScale + "rem",
    h5: ["1.4rem", "1.4rem", "1.6rem"],
    h6: fontSizeBase / modularScale + "rem",
};
var Heading = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#3B3B3B" : _b, fontSize = _a.fontSize, _c = _a.fontWeight, fontWeight = _c === void 0 ? "semibold" : _c, _d = _a.as, as = _d === void 0 ? "h2" : _d, others = __rest(_a, ["color", "fontSize", "fontWeight", "as"]);
    return (React.createElement(HeadingRebass, __assign({ color: color, fontSize: fontSize || fontStyles[as], fontWeight: fontWeight }, others)));
};
export default Heading;
